import(/* webpackMode: "eager", webpackExports: ["ProductCatalog"] */ "/app/src/components/products/ProductCatalog.tsx");
